module.exports = __webpack_public_path__ + "assets/img/text-to-speech-app3.20df8f96.png";